<template>
  <div>
    <div :style="allStyle">
      <span :style="preTextStyle">{{ conf.preText }}</span
      ><el-rate
        ref="rate"
        v-model="conf.value"
        class="valuation-rate"
        :style="valuationStyle"
        disabled
        :show-score="conf.showData && conf.valuationType === '0'"
        :show-text="conf.valuationType !== '0'"
        :text-color="conf.iconColor"
        :colors="[conf.iconColor, conf.iconColor, conf.iconColor]"
        :icon-classes="icons"
        :void-icon-class="this.conf.iconStyle"
        :disabled-void-icon-class="this.conf.iconStyle"
        score-template="{value}"
        :texts="showText"
      >
      </el-rate>
    </div>
  </div>
</template>

<script>
export default {
  name: "TumengValuation",
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    value() {
      return this.conf.value;
    },
    icons() {
      return [this.conf.iconStyle, this.conf.iconStyle, this.conf.iconStyle];
    },
    allStyle() {
      return {
        width: this.conf.width + 'px',
        height: this.conf.height + 'px',
        display: "flex",
        justifyContent: this.conf.textAlign,
        alignItems: this.conf.verticalAlign,
        fontSize: `${this.conf.fontSize}px`,
        background: this.conf.bgColor,
        whiteSpace: 'nowrap'
      };
    },
    valuationStyle() {
      return {
        "--fontSize": `${this.conf.fontSize}px`,
        "--fontColor": this.conf.iconColor,
        // width: '100%',
        lineHeight: `${this.conf.fontSize}px`,
        opacity: 1 - this.conf.transparency,
        textAlign: "center",
      };
    },
    preTextStyle() {
      return {
        fontSize: this.conf.preTextStyle.fontSize + 'px',
        fontFamily: this.conf.preTextStyle.font,
        color: this.conf.fontColor,
        fontWeight: this.conf.preTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.preTextStyle.isItaly ? "italic" : "normal",
        textDecoration: this.conf.preTextStyle.isUnderline,
      }
    },
    showText() {
      let text = [];
      switch (this.conf.valuationType) {
        case "0":
          text = [];
          break;
        case "1":
          text = [2, 4, 6, 8, 10];
          break;
        case "2":
          text = ["20%", "40%", "60%", "80%", "100%"];
          break;
      }
      return text;
    },
  },
  data() {
    return {
      // value: 3.8,
    };
  },
};
</script>

<style scoped lang="scss">
.valuation-rate {
  ::v-deep .el-rate__icon {
    font-size: #{"var(--fontSize)"};
  }
  ::v-deep .el-rate__text {
    font-size: #{"var(--fontSize)"};
  }
}
</style>
